import routes from '@config/routes';
import instance from '@instance';
import { getUserIpAddress } from '@utils/ip-tracking';
import { getCookie, setCookie } from 'cookies-next';

export const syncAnonymousUserWithIpCookie = async () => {
  if (getCookie('anonymous-user-id')) return;

  const ipAddress = getUserIpAddress();

  if (!ipAddress) return;

  const anonymousUser = await instance.server(routes.createAnonymousUser, {
    body: JSON.stringify({ ipAddress }),
    method: 'POST',
  });
  const response = await anonymousUser.json();

  setCookie('anonymous-user-id', response.id);
};
